import { GOLD_PRICE_IS_ACTIVE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GeneralGetGoldPriceIsActive(goldTypeValue, priceTypeValue){
  const api = `${GOLD_PRICE_IS_ACTIVE_API}${goldTypeValue}/${priceTypeValue}/`;
  return axiosHttp.get(api)
}
